import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const availabilityParams = {
    date: '2021-05-11',
    lat: -37.781,
    lng: 145.339,
};

const initialState = {
    availability: { Success: false, Data: { Count: 0 } },
    status: 'idle',
    error: null,
    params: availabilityParams,
};

export const searchTeachers = createAsyncThunk(
    'school/searchTeachers',
    async token => {
        const response = await axios.get('/searchTeachers', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/searchTeachers`,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);
// need to obtain token silently before the API call and remove from availability page

const searchSlice = createSlice({
    name: 'searchTeacher',
    initialState,
    reducers: {
        searchAdded(state, action) {
            const {
                grade,
                address,
                teacherName,
                teacherProfile,
                skills,
                otherSkills,
                bio,
                geoJSON,
                startDate,
                endDate,
                status,
                repeat,
                pk1,
                sk1,
            } = action.payload;
            const currentAvailability = state.search;
            if (currentAvailability) {
                currentAvailability.otherSkills = otherSkills;
                currentAvailability.address = address;
                currentAvailability.teacherName = teacherName;
                currentAvailability.teacherProfile = teacherProfile;
                currentAvailability.skills = skills;
                currentAvailability.bio = bio;
                currentAvailability.grade = grade;
                currentAvailability.geoJSON = geoJSON;
                currentAvailability.startDate = startDate;
                currentAvailability.endDate = endDate;
                currentAvailability.repeat = repeat;
                currentAvailability.status = status;
                currentAvailability.sk1 = sk1;
                currentAvailability.pk1 = pk1;
            }
        },
    },
    extraReducers: {
        [searchTeachers.pending]: (state, action) => {
            state.status = 'loading';
        },
        [searchTeachers.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            // Add any fetched posts to the array
            console.log(
                'Need to format date into this ' +
                    JSON.stringify(action.payload.availability.Message)
            );

            state.availability = action.payload.availability.Message;
        },
    },
});

export const { searchAdded } = searchSlice.actions;

export default searchSlice.reducer;

export const getSearch = state => state.search;
